import React  from 'react'

export default function UndefinedTemplateMessage ({row}) {
  return (
    <div>
      <div dangerouslySetInnerHTML={{__html:row.header}} />
      <div dangerouslySetInnerHTML={{__html:row.text}} />
    </div>
  )
}